export default __webpack_public_path__ + "fonts/68e3a4f9a8d8c679b4aeeec538091708.eot";